<template>
  <ImportDialog
    :apply="apply"
    :create-file-handler="createFileHandler"
    :files.sync="files"
    :files-types="['xlsx']"
    only_one
    :subtitle="$t('Tenders.ImportLotsWithDataDescription')"
    :title="$t('Tenders.ImportLotsWithData')"
    @close="close">
    <template #activator="{ open }">
      <sButton
        class="mr-3 ml-auto"
        :disabled="loadImportLots || disabled || (tender && !$can('import', 'lots'))"
        icon="import"
        :loading="loadImportLots"
        small
        type="text"
        @click="open">
        {{ $t('Tenders.ImportXLS') }}
      </sButton>
    </template>
    <template #actions>
      <div class="width-100">
        <sButton
          class="mb-1"
          icon="download"
          :loading="template && !template.file"
          type="text"
          @click="downloadTemplate">
          {{ $t('Tenders.DownloadXLSTemplate') }}
        </sButton>
      </div>
    </template>
  </ImportDialog>
</template>
<script>
import ImportDialog from 'components/common/dialogs/ImportDialog.vue'

import { TenderLotTemplateFile, TenderLotFile } from '@/types/commonFile.js'
import { eventBus } from '@/main'

export default {
  name: 'ImportGroupXLS',
  data() {
    return {
      files: [],
      loadImportLots: false,
      template: null
    }
  },
  props: {
    disabled: Boolean,
    tender: Object
  },
  mounted() {
  },
  methods: {
    apply() {
      this.loadImportLots = true
      this.$emit('startImportLots')
      this.files[0]?.uploadFile()
        .then((res) => {
          if (res.data?.errors?.length) {
            eventBus.$emit('showErrorSnackbar', res.data.errors)
            this.close()
            return
          }
          let ret = res.data?.data?.editTenderDraftWithImportLotsWithGroup
          this.$emit('onSubmitTender', ret)
          this.close()
        })
        .catch(er => {
          this.$emit('finishImportLots')
          this.$log_error(er.response.data)
        })
        .finally(() => {
          this.$emit('finishImportLots')
          this.$set(this, 'files', [])
          this.loadImportLots = false
        })
    },
    close() {
      this.files = []
    },
    downloadTemplate() {
      const uri = window.config.GrapgQlUrl + '/files/getLotWithPositionsImportTemplate/' + this.tender.tenderId
      this.template = new TenderLotTemplateFile(uri, this.$t('Common.templateImportSpecifyLots'))
      try {
        this.template.saveFile()
      } catch (_) {
        this.template = null
      }
    },
    createFileHandler(file) {
      return new TenderLotFile(file, this.tender.tenderId, 'uploadLotsWithGroup')
    }
  },
  components: {
    ImportDialog
  }
}
</script>
